import { useEffect, useState } from 'react';
import L from 'leaflet';
import { LEAFLET_CSS } from './leafletCss';

declare global { interface Window { L: any; } }

/**
 * Leaflet is now BUNDLED (npm `leaflet`) instead of loaded from a CDN. The Airtable
 * extension iframe's CSP silently blocked the external <script>, leaving the map blank
 * with no error. Bundling removes that failure mode entirely — no network, no CSP
 * allowance needed. The stylesheet is inlined (leafletCss.ts) and injected once.
 */
let injected = false;
function ensureLeaflet(): boolean {
  if (typeof window === 'undefined') return false;
  if (!injected) {
    if (!document.getElementById('leaflet-css')) {
      const s = document.createElement('style');
      s.id = 'leaflet-css';
      s.textContent = LEAFLET_CSS;
      document.head.appendChild(s);
    }
    window.L = L;
    injected = true;
  }
  return true;
}

export function useLeaflet(): { ready: boolean; failed: boolean } {
  const [ready, setReady] = useState<boolean>(() => ensureLeaflet());
  useEffect(() => { setReady(ensureLeaflet()); }, []);
  // Bundled — it cannot fail to load. `failed` retained for the MapCanvas contract.
  return { ready, failed: false };
}
